import { axios } from '@slg/web-customer-shared';

const domain = 'd2d-customer/public/v1/tenant/{TENANT_NAME}/service/{SERVICE_NAME}/booking-requests/price';

const bookingRequestNightCardsCheck = (
  bookingRequestNightCardsModel: Record<string, unknown> = {},
) => axios.post(`${domain}`, bookingRequestNightCardsModel);

export { bookingRequestNightCardsCheck };
